import React from 'react';
import styles from './index.less';
import ARROW from '@tencent/docs-design-resources/icon/desktop/svg/arrowhead_down_12.svg';

interface ICustomSelect {
    children?: React.ReactNode;
    style?: React.CSSProperties;
}

/**
 * wb的toolbar input样式目前只支持文字内容，做个自定义的，等wb支持吧
 */
export class CustomSelect extends React.Component<ICustomSelect, any> {
    render() {
        return <div
            className={styles['wb-custom-select']}
            style={{
                ...this.props.style,
            }}
        >
            <div
                className={styles['wb-custom-select-content-container']}
            >
                { this.props.children }
            </div>
            <div
                className={styles['wb-custom-select-arrow']}
            />
        </div>;
    }
}
